import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Grid,
  Paper,
  Divider,
  Button,
  Alert,
} from "@mui/material";


const SingleStockInvestment = ({
  valueStocks,
  selectedStock,
  selectedStockCurrentPrice,
  investmentAmount,
  quantity,
  totalValue,
  orderMessage,
  severity,
  handleSelectSell,
  handleInvestmentAmount,
  handlePurchaseSingle,
}) => {
  return (
    <Box sx={{ p: 4, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "#2d4890" }}>
        Trade Individual Value Stock
      </Typography>

      <TextField
        select
        label="Select Stock"
        value={selectedStock?.Ticker || ""}
        onChange={handleSelectSell}
        fullWidth
        sx={{ mb: 4 }}
      >
        {valueStocks.map((stock) => (
          <MenuItem key={stock.Ticker} value={stock.Ticker}>
            {stock.Ticker}
          </MenuItem>
        ))}
      </TextField>

      {selectedStock && (
        <Grid container spacing={4}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: 3,
                border: "1px solid #ddd",
                borderRadius: 2,
                backgroundColor: "#fff",
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Current Price: <strong>₹{selectedStockCurrentPrice}</strong>
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                ROE/ROCE (2024): {selectedStock.roe} / {selectedStock.roce}
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Market Cap: {selectedStock["MKT CAP"]}
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                5D Avg Vol (Cr): {selectedStock["5 Day Avg Volume (Cr)"]}
              </Typography>

              <TextField
                label="Investment Amount (₹)"
                type="number"
                value={investmentAmount}
                onChange={handleInvestmentAmount}
                fullWidth
              />

              <Typography sx={{ mt: 2, fontWeight: 500 }}>
                Quantity to Buy: <strong>{quantity}</strong>
              </Typography>
            </Box>
          </Grid>

          {/* Right Column - Order Summary */}
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                p: 4,
                backgroundColor: "#ffffff",
                border: "1px solid #ccc",
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <Typography variant="h6" gutterBottom sx={{ color: "#2d4890", fontWeight: "bold" }}>
                Order Summary
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Typography sx={{ mb: 0.5 }}>Stock: {selectedStock.Ticker}</Typography>
              <Typography sx={{ mb: 0.5 }}>Company: {selectedStock["Company Name"]}</Typography>
              <Typography sx={{ mb: 0.5 }}>Sector: {selectedStock.Sector}</Typography>
              <Typography sx={{ mb: 0.5 }}>Industry: {selectedStock.Industry}</Typography>
              <Typography sx={{ mb: 0.5 }}>Price: ₹{selectedStockCurrentPrice}</Typography>
              <Typography sx={{ mb: 0.5 }}>Quantity: {quantity}</Typography>
              <Typography sx={{ mb: 2 }}>Total Value: ₹{totalValue}</Typography>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={handlePurchaseSingle}
              >
                Buy Now
              </Button>

              {orderMessage && (
                <Alert severity={severity} sx={{ mt: 2 }}>
                  {orderMessage}
                </Alert>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default SingleStockInvestment;
